module.exports = __webpack_public_path__ + "static/media/iq.af876b01.svg";